module.exports = __webpack_public_path__ + "yandex_kassa_alfa_bank.17b61526711d388ea25e0c2ef3e7afaa.png";